import React, { useRef, useState } from "react";
import API from "../config/API";
import LogoutIcon from "@mui/icons-material/Logout";
import { Button } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import fileDownload from "js-file-download";

const RightSidebar = ({
  selectedReport,
  selectedReportFiles,
  setSelectedReportFiles,
  isLoadingRightSidebar,
  setIsLoadingRightSidebar,
  isCollapsed,
  toggleCollapse,
  darkMode,
  setDarkMode,
  logout,
  justSwitchedReport,
  setJustSwitchedReport,
  refreshReportsList,
  showSnackbar,
  refreshReportFilesList,
  isLoading,
  setIsLoading,
  buttonStyle,
  spinnerStyle,
  logoutColor,
  genericColor,
}) => {
  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleViewFile = async (fileId, originalName) => {
    try {
      const response = await API.get(`/files/view/${fileId}`, {
        responseType: "blob",
        headers: {
          token: localStorage.getItem("token"),
        },
      });

      fileDownload(response.data, originalName); // triggers download
    } catch (err) {
      console.error("Failed to download file:", err);
      showSnackbar("Failed to download file", "error");
    }
  };

  const handleDeleteFile = async (fileId) => {
    try {
      setIsLoadingRightSidebar(true);
      const res = await API.delete(`/files/${fileId}`);
      if (res.status === 200) {
        setSelectedReportFiles((prev) => prev.filter((f) => f._id !== fileId));
      }
      showSnackbar("File deleted", "success");
    } catch (err) {
      console.error("Failed to delete file:", err);
      showSnackbar("Failed to delete file", "error");
    } finally {
      setIsLoadingRightSidebar(false);
    }
  };

  const handleFileUpload = async (e) => {
    setIsLoadingRightSidebar(true);

    const files = Array.from(e.target.files || e.dataTransfer.files);
    const report_id = selectedReport?.report_id;
    console.log("files", files);
    console.log("conv id", report_id);

    if (!report_id) {
      showSnackbar("No conversation selected", "error");
      setIsLoadingRightSidebar(false);
      return;
    }

    if (files.length === 0) {
      showSnackbar("No files detected. Try again.", "error");
      setIsLoadingRightSidebar(false);
      return;
    }
    try {
      const uploadedFiles = [];

      for (const file of files) {
        const formData = new FormData();
        formData.append("file", file);

        const res = await API.post(`/reports/${report_id}/files`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        //if (res.status === 201) {
        //uploadedFiles.push({ name: res.data.original_name });
        //}
      }
      refreshReportFilesList();
      setSelectedReportFiles((prev) => [...uploadedFiles, ...prev]);
      if (justSwitchedReport == true) {
        refreshReportsList();
        setJustSwitchedReport(false);
      }
      showSnackbar("File uploaded successfully", "success");
    } catch (err) {
      console.error("Upload failed:", err);
      const message =
        err?.response?.data?.error || err.message || "Upload failed";
      console.log("RES", message);
      showSnackbar(message, "error");
    } finally {
      setIsLoadingRightSidebar(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    handleFileUpload(e);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleClickDropzone = () => {
    if (isLoading == true) {
      return false;
    }
    fileInputRef.current.click();
  };

  return (
    <div
      className="sidebar-right grey lighten-4"
      style={{
        width: isCollapsed ? "60px" : "400px",
        padding: isCollapsed ? "10px" : "20px",
        height: "100vh",
        borderLeft: "1px solid #ccc",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        style={{
          alignSelf: "flex-end",
          marginBottom: isCollapsed ? "0" : "20px",
        }}
      >
        <button className="btn-flat" onClick={toggleCollapse} title="Collapse">
          <i className="material-icons">
            {isCollapsed ? "chevron_left" : "chevron_right"}
          </i>
        </button>
      </div>

      {!isCollapsed && (
        <>
          {/*   <div
            onClick={handleClickDropzone}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            style={{
              width: "100%",
              height: 100,
              border: `2px dashed ${genericColor}`,
              borderRadius: "10px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "30px",
              backgroundColor: isDragging ? "transparent" : "transparent",
              color: genericColor,
              fontWeight: 500,
              cursor: "pointer",
              transition: "background-color 0.2s",
            }}
          >
            {isDragging ? "Drop files here…" : "Click or drag files to upload"}
            <input
              type="file"
              disable={isLoading}
              multiple
              ref={fileInputRef}
              onChange={handleFileUpload}
              style={{ display: "none" }}
            />
          </div>

          <ul
            className="collection"
            style={{ width: "100%", border: "none", marginBottom: "30px" }}
          >
            <li className="collection-item" style={{ border: "none" }}>
              <strong>Status:</strong> On
            </li>
            <li className="collection-item" style={{ border: "none" }}>
              <strong>Time:</strong> Every day 11:00 am
            </li>
            <li className="collection-item" style={{ border: "none" }}>
              <strong>Recipients:</strong> TO: marco@tim.it, CC: marco@iol.it
            </li>
          </ul>*/}

          <div
            style={{
              marginBottom: "30px",
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <a
              style={buttonStyle}
              className="btn waves-effect waves-light"
              href="#!"
              disabled={isLoading}
            >
              Files
            </a>
          </div>

          {isLoadingRightSidebar ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "30px",
              }}
            >
              <div className="preloader-wrapper active">
                <div className="spinner-layer spinner-teal-only">
                  <div className="circle-clipper left">
                    <div className="circle" style={spinnerStyle}></div>
                  </div>
                  <div className="gap-patch">
                    <div className="circle" style={spinnerStyle}></div>
                  </div>
                  <div className="circle-clipper right">
                    <div className="circle" style={spinnerStyle}></div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <ul
              className="collection"
              style={{ width: "100%", border: "none" }}
            >
              {Array.isArray(selectedReportFiles) &&
                selectedReportFiles.map((file, index) => (
                  <li
                    key={file._id || index}
                    className="collection-item"
                    style={{
                      marginBottom: "10px",
                      borderRadius: "10px 10px 10px 0",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span>
                      {file.name.length > 35
                        ? `${file.name.slice(0, 35)}...`
                        : file.name}
                    </span>
                    <span style={{ display: "flex", alignItems: "center" }}>
                      {/* Open File Icon */}
                      <OpenInNewIcon
                        fontSize="small"
                        style={{
                          cursor: "pointer",
                          marginRight: "8px",
                          width: "15px",
                          color: genericColor,
                        }}
                        onClick={() => handleViewFile(file._id, file.name)}
                      />

                      {/* Delete File X */}
                      <span
                        style={{
                          cursor: "pointer",
                          color: genericColor,
                          fontWeight: "bold",
                        }}
                        onClick={() => {
                          if (window.confirm("Delete this file?"))
                            handleDeleteFile(file._id);
                        }}
                      >
                        &times;
                      </span>
                    </span>
                  </li>
                ))}
            </ul>
          )}

          <div style={{ marginTop: "auto", alignSelf: "flex-end" }}>
            <Button
              onClick={logout}
              variant="outlined"
              size="small"
              sx={{
                position: "absolute",
                bottom: 20,
                right: 20,
                borderColor: logoutColor,
                minWidth: 0,
                padding: "6px",
                color: logoutColor,
              }}
            >
              <LogoutIcon />
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default RightSidebar;
